import IUserMenu from '../interfaces/IUserMenu';
import { resolveMenuPath } from './resolveMenuPath';

function findMenuByField<T extends keyof IUserMenu>(
  menus: IUserMenu[] = [],
  field: T,
  value: IUserMenu[T],
): IUserMenu | null {
  if (!menus || !menus.length) return null;

  for (const menu of menus) {
    if (!menu) continue;

    if (field === 'path') {
      const resolvedPath = resolveMenuPath(menu);
      const searchVal = String(value ?? '').replace(/\/+$/, '') || '/';
      if (resolvedPath && resolvedPath === searchVal) {
        return menu;
      }
    } else {
      const menuVal = String(menu[field] ?? '');
      const searchVal = String(value ?? '');
      if (menuVal === searchVal) {
        return menu;
      }
    }

    if (menu.children && menu.children.length > 0) {
      const found = findMenuByField(menu.children, field, value);
      if (found) return found;
    }
  }
  return null;
}

export default findMenuByField;
